var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSafetyHarness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4,33.24V56H26V33.24ZM27.77,21.43c.92,0,1.85,0,2.77,0A2.42,2.42,0,0,1,33.21,24c.08,2,.08,4,0,6a2.39,2.39,0,0,1-2.55,2.51c-2,.08-4,.08-6,0a2.36,2.36,0,0,1-2.49-2.55c-.05-2-.05-3.9,0-5.85,0-1.75.92-2.59,2.69-2.66C25.82,21.4,26.79,21.43,27.77,21.43ZM28,22.71H27.8c-5,0-4.34-.58-4.38,4.3,0,4.65-.58,4.21,4.19,4.2s4.31.57,4.33-4.39C32,22.21,32.29,22.69,28,22.71Zm1.4.63h.13c1.91,0,1.73.3,1.72,3.37v.44c0,3,.2,3.39-1.56,3.42h-2l-1.52,0h-.3c-2.09,0-1.81-.32-1.8-3.38v-.43c0-3.19-.28-3.41,1.93-3.42h1.65C28.38,23.36,29,23.34,29.43,23.34Zm20.2,1.81v3.63H34V25.15Zm-29-.06a1.17,1.17,0,0,1,.81.79,27,27,0,0,1,0,2.87H6v-3.7C10.94,25.05,15.81,25,20.66,25.09ZM39.13,0,42.56,1.6,33.31,21.21l-3.89-.61ZM16.2,0l9.73,20.61-3.89.6L12.79,1.61Z",
    fill: "#0A0D0D"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafetyHarness);
export default __webpack_public_path__ + "static/media/safety-harness.bf0981e6.svg";
export { ForwardRef as ReactComponent };